import AjaxRequest from './AjaxRequest';

export default class Retouching
{
    getRetouching(data) {
        return new AjaxRequest().get('retouching', data)
    }
}
